export default {"src":"/_next/static/media/LYFT.81011677.svg","height":18,"width":18};